import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { OtrosPagosComponent } from './formulario/formulario.component';
import { DevolucionComponent } from './formulario/devolucion.component';
import { OtrosPagosListaComponent } from './otros-pagos-lista/lista.component';
import { ListaComponent } from './lista/lista.component';
import { AuthGuard } from '../../auth-guard.service';

const routes: Routes = [
  {
    path: 'servicio-financiero/otro-pago',
    children: [
      { path: 'lista', component: ListaComponent},
      { path: 'nuevo', component: OtrosPagosComponent },
      { path: 'editar/:id', component: OtrosPagosComponent},
       { path: 'devolucion/:id', component: DevolucionComponent},
    ],
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class VentaRoutingModule { }
